import React from "react";
import { getUserAvatarUrl } from "../utils/navigationUtils";

const UserAvatarButton = ({ user, onClick }) => {
  const fullName = `${user?.prenom || ""} ${user?.nom || ""}`.trim();

  return (
    <button
      type="button"
      onClick={onClick}
      className="
        group inline-flex h-9 max-w-[44px] shrink-0 items-center gap-2 overflow-hidden rounded-xl
        border border-white/10 bg-white/10 py-1 pl-1 pr-1 text-white transition
        hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-300
        sm:h-10 sm:max-w-[220px] sm:rounded-2xl sm:py-1.5 sm:pl-1.5 sm:pr-3
      "
      title={fullName || "Mon profil"}
    >
      <img
        src={getUserAvatarUrl(user)}
        alt={fullName || "Avatar utilisateur"}
        className="h-7 w-7 shrink-0 rounded-lg object-cover ring-2 ring-white/20 sm:h-8 sm:w-8 sm:rounded-xl"
      />

      <span className="hidden max-w-[150px] truncate text-sm font-bold md:block">
        {fullName || "Profil"}
      </span>
    </button>
  );
};

export default UserAvatarButton;